import React from 'react';
import { AdvancedSelectComponent, AdvancedSubHeaderComponent } from '@vivli/shared/components';
import { amrFieldTitleStyle, inputGroupBreakStyle } from '../../search-filters.styles';
import { FilterGroupComponent } from '../../filter-group.component';
import { useAmrSearchOptionsContext } from '@vivli/features/search/infrastructure/context';
import { useSearchApiContext } from '@vivli/core/infrastructure/context';

export const ThirdFilterGroupComponent = () => {
    const { amrFilterValues } = useSearchApiContext();
    const { countrySelectedOptions, setCountrySelectedOptions, regionSelectedOptions, setRegionSelectedOptions } =
        useAmrSearchOptionsContext();

    const countryOptions = amrFilterValues?.countries.map((l) => ({ value: l.value, label: l.value }));
    const regionOptions = amrFilterValues?.regions.map((l) => ({ value: l.value, label: l.value }));

    return (
        <FilterGroupComponent>
            <div style={inputGroupBreakStyle}>
                <AdvancedSubHeaderComponent title={'Country'} style={amrFieldTitleStyle} />
                <AdvancedSelectComponent
                    dataId={'amrSearchCountry'}
                    isMulti={true}
                    isSearchable={true}
                    onChange={setCountrySelectedOptions}
                    options={countryOptions}
                    selectedOptions={countrySelectedOptions}
                />
            </div>

            <div>
                <AdvancedSubHeaderComponent title={'Region'} style={amrFieldTitleStyle} />
                <AdvancedSelectComponent
                    dataId={'amrSearchRegion'}
                    isMulti={true}
                    isSearchable={true}
                    onChange={setRegionSelectedOptions}
                    options={regionOptions}
                    selectedOptions={regionSelectedOptions}
                />
            </div>
        </FilterGroupComponent>
    );
};
